import React from 'react';

import { VStack, SvgWrapper } from '@adc/parallax-component-library';
import AbbottLogo from '../../images/abbott-logo.svg';

/**
 * LandingPageHeader component that displays the Abbott logo at the top of the landing page.
 * It uses a vertical stack layout and includes a wrapper for SVG scaling.
 * @returns {React.JSX.Element}
 */
export default function LandingPageHeader() {
  return (
    <VStack padding="$6" testID="landing-page-header">
      <VStack alignItems="center" height={140} marginTop={-100}>
        <SvgWrapper scaling={true}>
          <AbbottLogo />
        </SvgWrapper>
      </VStack>
    </VStack>
  );
}
